import {Component} from '@angular/core';
import {Events, NavController, ViewController, Tabs, Platform} from 'ionic-angular';
import {HttpClient} from '@angular/common/http'
import {ProfileCreateAccountPage} from "../profile-create-account/profile-create-account";
import {ProfilePage} from "../profile/profile";
import {ProfileForgotPasswordPage} from "../profile-forgot-password/profile-forgot-password";
import {ApiErrorHandlerProvider} from "../../providers/api-error-handler/api-error-handler";
import {PushNotificationServiceProvider} from "../../providers/push-notification-service/push-notification-service";
import {StripeServiceProvider} from "../../providers/stripe-service/stripe-service";
import {TeamServiceProvider} from "../../providers/team-service/team-service";

/**
 * Generated class for the ProfileLoginPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-profile-login',
    templateUrl: 'profile-login.html',
})
export class ProfileLoginPage {

    ProfileCreateAccountButton: any;
    ProfileForgotPasswordButton: any;

    errors: {};
    loading: boolean;
    formLoginLoading: boolean;
    email: string;
    password: string;
    tuid: string;
    account: any;
    referral: string;

    constructor(
      public navCtrl: NavController,
      public events: Events,
      private viewCtrl: ViewController,
      private http: HttpClient,
      private apiErrorHandler: ApiErrorHandlerProvider,
      private platform: Platform,
      private pushService: PushNotificationServiceProvider,
      private stripeService: StripeServiceProvider,
      private teamProvider: TeamServiceProvider
    ) {
        this.ProfileCreateAccountButton = ProfileCreateAccountPage;
        this.ProfileForgotPasswordButton = ProfileForgotPasswordPage;
    }

    ionViewWillEnter() {

        // console.log(localStorage.getItem('devicePushNotificationToken'));

        // Check if there is a login referral -> prompt from other action
        if (localStorage.getItem('refer')) {
            this.referral = localStorage.getItem('refer');
            localStorage.removeItem('refer');
        } else {
            this.referral = null;
        }

        this.viewCtrl.showBackButton(false);
        this.tuid = localStorage.getItem('tuid');
        if (this.tuid) {
            this.loading = true;
            this.getUser().then(() => {
                this.navCtrl.push(ProfilePage, {'account': this.account}).then(() => {
                    // Set loading to false once the view has been pushed so we don't
                    // reveal the view that was previously hidden
                    this.loading = false;
                });
            }, (error) => {
                localStorage.clear();
                this.loading = false;
            });
        }
    }

    getUser() {
        return new Promise((resolve, reject) => {
            this.http.get('/user/' + this.tuid).subscribe(res => {
                this.account = res;
                 return resolve(true);
            }, error => {
                this.errors = this.apiErrorHandler.handleError(error);
                return reject(this.errors);
            })
        });
    }

    login() {
        this.formLoginLoading = true;

        this.http.post('/login', {
            email: this.email,
            password: this.password
        }).subscribe((data: any) => {

            // Sanitise local storage values before logging in.
            localStorage.clear();

            // Set the user details to the localStorage.
            localStorage.setItem('tuid', data.id);
            localStorage.setItem('accountType', data.account_type);

            if (data.current_team_id) {
              localStorage.setItem('currentTeamId', data.current_team_id);
            }

            localStorage.setItem('lastBookingTeamId', data.last_booking_team_id);

            // Set the tuid now the user is logged in successfully
            this.tuid = data.id;

            // Create a login event
            this.events.publish('user:login');

            // Redirect to the user profile page
            this.getUser().then(() => {

                // If referral exist -> redirect to parent tab
                if (this.referral) {
                    let tabBar: Tabs = this.navCtrl.parent;
                    let referral = parseInt(this.referral);
                    this.referral = null;
                    tabBar.select(referral);
                    return;
                }

                if (this.teamProvider.isCustomApp()){
                  this.teamProvider.getShopLocations().then((shops: any) => {
                    if (shops.length === 1) {
                      localStorage.setItem('singleShop', 'true');
                      localStorage.removeItem('ownerId');
                    }

                    if (shops.length > 1) {
                      localStorage.setItem('multiShop', 'true');
                      localStorage.setItem('ownerId', shops[0].owner_id);
                    }

                    this.openProfilePage();
                  })
                } else {
                  this.openProfilePage();
                }

            }).then(() => {
              this.stripeService.registerWithStripe();
            });

        }, error => {
            this.formLoginLoading = false;
            this.errors = this.apiErrorHandler.handleError(error);
        }, () => {
            this.pushService.registerForPush();
        })
    }

    openProfilePage() {
      return this.navCtrl.push(ProfilePage, {'account': this.account}).then(() => {
        // Only after the view has been pushed will we reset current values to false otherwise
        // we'll have a strange behaviour where the spinner reveals the view behind too early
        this.email = null;
        this.password = null;
        this.errors = {};
        this.formLoginLoading = false;
      });
    }
}



// WEBPACK FOOTER //
// ./src/pages/profile-login/profile-login.ts